// @flow
import { ERROR_SAVE, CLEAR_ERROR } from "../constants/actionTypes";

export function saveError(payload: any) {
  return { type: ERROR_SAVE, payload };
}

export function clearError() {
  return { type: CLEAR_ERROR };
}
